import { applyMiddleware, compose as reduxCompose, createStore as reduxCreateStore, Reducer, Store } from "redux";
import createSagaMiddleware, { SagaMiddleware } from "redux-saga";

import { IAppState, SagaWithReturnType } from "@multiweb/types/react";

/** Nastavení zásuvného modulu Redux DevTools */
type ReduxDevToolsComposeOptions = {
    /** Příznak, zda má být dostupný zásobník volání akcí */
    trace: boolean;
};

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: (options: ReduxDevToolsComposeOptions) => typeof reduxCompose;
    }
}

export type StoreInfo = {
    readonly store: Store;
    readonly rootSagaPromise: Promise<void>;
    readonly runSaga: SagaMiddleware["run"];
};

/**
 * Vytvoří store pro stav Reactové části aplikace.
 *
 * @param isDevMode Indikace vývojového módu. Pokud je aktivní, zapojí se do middleware redux-dev-tools.
 * @param rootReducer Kořenový reducer aplikace.
 * @param rootSaga Kořenová sága aplikace.
 * @return Objekt obsahující samotný store společně s Promise kořenové ságy, která umožňuje specifikovat error handling pro ságy.
 */
export const createStore = (isDevMode: boolean, rootReducer: Reducer<IAppState>, rootSaga: SagaWithReturnType): StoreInfo => {
    const sagaMiddleware = createSagaMiddleware();
    const compose = isDevMode && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: false })
        : reduxCompose;
    const middleware = compose(
        applyMiddleware(sagaMiddleware),
    );
    const store = reduxCreateStore(rootReducer, middleware);
    const rootSagaPromise = sagaMiddleware.run(rootSaga).toPromise();
    return {
        store,
        rootSagaPromise,
        runSaga: sagaMiddleware.run,
    };
};
